export class FiltroExt {
  public NroDocumento: string;
  public captcha: string;
}
